import styles from './NavigationControls.module.css';

/**
 * NavigationControls Component
 *
 * Displays month navigation controls with previous/next buttons and current month display.
 * Shows a CLOSED badge when the month is closed.
 *
 * Props:
 * - selectedMonthDisplay (string): Display name for current month
 * - isClosed (boolean): Whether the selected month is closed
 * - isPrevDisabled (boolean): Whether previous button should be disabled
 * - isNextDisabled (boolean): Whether next button should be disabled
 * - onPreviousMonth (function): Called when user clicks previous month
 * - onNextMonth (function): Called when user clicks next month
 */
function NavigationControls({
    selectedMonthDisplay,
    isClosed,
    isPrevDisabled,
    isNextDisabled,
    onPreviousMonth,
    onNextMonth
}) {
    const handlePreviousMonth = (e) => {
        e.preventDefault();
        onPreviousMonth();
    };

    const handleNextMonth = (e) => {
        e.preventDefault();
        onNextMonth();
    };

    return (
        <div className={styles.container}>
            <button
                onClick={handlePreviousMonth}
                disabled={isPrevDisabled}
                className={styles.navButton}
            >
                ← Previous
            </button>

            <h3 className={styles.monthDisplay}>
                {selectedMonthDisplay}
                {isClosed && (
                    <span className={styles.closedBadge}>
                        CLOSED
                    </span>
                )}
            </h3>

            <button
                onClick={handleNextMonth}
                disabled={isNextDisabled}
                className={styles.navButton}
            >
                Next →
            </button>
        </div>
    );
}

export default NavigationControls;
